import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";

const HomePage = () => {
    const [shows, setShows] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${process.env.REACT_APP_STORAGE_URL}/info.json`)
            .then((response) => response.json())
            .then((data) => setShows(data))
            .catch((error) => console.error("Failed to fetch shows:", error));
    }, []);

    const handleShowClick = (name) => {
        navigate(`/seasons/${name}`); // Переход с использованием "s1"
    };

    return (
        <div className="home-page">
            <div style={{padding: "20px"}}>
                <h1>Библиотека</h1>
                <div className='series-container'>
                    {shows.map((show) => (
                        <div key={show.name} className="series-card"
                             onClick={() => handleShowClick(show.name)}>
                            <img
                                src={`${process.env.REACT_APP_STORAGE_URL}/${show.poster}`}
                                alt={show.title}
                                style={{width: "100%", borderRadius: "10px"}}
                            />
                            <h2>{show.title}</h2>
                            <p>{show.years}</p>
                        </div>
                    ))}


                    {/* REMOVE THIS */}{shows.map((show) => (
                    <div key={show.name} className="series-card"
                         onClick={() => handleShowClick(show.name, Object.keys(show.series)[0])}>
                        <img
                            src={`${process.env.REACT_APP_STORAGE_URL}/${show.poster}`}
                            alt={show.title}
                            style={{width: "100%", borderRadius: "10px"}}
                        />
                        <h2>{show.title}</h2>
                        <p>{show.years}</p>
                    </div>
                ))}{shows.map((show) => (
                    <div key={show.name} className="series-card"
                         onClick={() => handleShowClick(show.name, Object.keys(show.series)[0])}>
                        <img
                            src={`${process.env.REACT_APP_STORAGE_URL}/${show.poster}`}
                            alt={show.title}
                            style={{width: "100%", borderRadius: "10px"}}
                        />
                        <h2>{show.title}</h2>
                        <p>{show.years}</p>
                    </div>
                ))}{shows.map((show) => (
                    <div key={show.name} className="series-card"
                         onClick={() => handleShowClick(show.name, Object.keys(show.series)[0])}>
                        <img
                            src={`${process.env.REACT_APP_STORAGE_URL}/${show.poster}`}
                            alt={show.title}
                            style={{width: "100%", borderRadius: "10px"}}
                        />
                        <h2>{show.title}</h2>
                        <p>{show.years}</p>
                    </div>
                ))}{shows.map((show) => (
                    <div key={show.name} className="series-card"
                         onClick={() => handleShowClick(show.name, Object.keys(show.series)[0])}>
                        <img
                            src={`${process.env.REACT_APP_STORAGE_URL}/${show.poster}`}
                            alt={show.title}
                            style={{width: "100%", borderRadius: "10px"}}
                        />
                        <h2>{show.title}</h2>
                        <p>{show.years}</p>
                    </div>
                ))}{shows.map((show) => (
                    <div key={show.name} className="series-card"
                         onClick={() => handleShowClick(show.name, Object.keys(show.series)[0])}>
                        <img
                            src={`${process.env.REACT_APP_STORAGE_URL}/${show.poster}`}
                            alt={show.title}
                            style={{width: "100%", borderRadius: "10px"}}
                        />
                        <h2>{show.title}</h2>
                        <p>{show.years}</p>
                    </div>
                ))}
                </div>
            </div>
        </div>
    );
};

export default HomePage;
